/**
 * Соответствие префикса пути → ключ 3D-иконки в platform-assets/moduls/icons.
 *
 * Реестр имён — только существующие пары `*_white.jpg` / `*_dark.jpg`:
 *   WMS, Shop, Orders, Market, Delivery, Logistics, CRM, HRM, Integrations
 * (см. markbase.ru/platform-assets/moduls/icons/README.md).
 * Новые ключи в этом массиве не добавлять без появления файлов иконок и строки в README.
 *
 * Для маршрутов без подходящего префикса `getPlatformAssetKeyForPath` возвращает null
 * (чип в Header / полоса HelperSidebar с 3D-иконкой не показываются).
 *
 * Порядок важен: сначала более длинные префиксы.
 *
 * Companion (WaySen): `resolveModuleKey` / `COMPANION_MODULE_ROUTE_PREFIXES` —
 * логические moduleKey для CMS scenes (не путать с 3D asset keys).
 */
export const ROUTE_PLATFORM_ASSET_PREFIXES = [
  ['/integrations/authorize', 'Integrations'],
  ['/modules/integrations-admin', 'Integrations'],
  ['/connections', 'Integrations'],
  ['/exchange-log', 'Integrations'],
  ['/api-keys', 'Integrations'],
  ['/analytics/settings', 'Integrations'],
  ['/analytics', 'Integrations'],
  ['/modules/feed', 'Shop'],
  ['/modules/finance', 'Integrations'],
  ['/settings/api-keys', 'Integrations'],
  ['/settings/prices', 'Shop'],
  ['/settings/currencies', 'Shop'],
  ['/products/composite', 'Shop'],
  ['/product-groups', 'Shop'],
  ['/file-import', 'Shop'],
  ['/images-management', 'Shop'],
  ['/marking', 'Shop'],
  ['/expiry-settings', 'Shop'],
  ['/modules/logistics', 'Logistics'],
  ['/modules/delivery', 'Delivery'],
  ['/modules/orders', 'Orders'],
  ['/ops', 'Orders'],
  ['/modules/wms', 'WMS'],
  ['/modules/shop', 'Shop'],
  ['/modules/company-services-booking', 'Shop'],
  ['/modules/crm', 'CRM'],
  ['/modules/hrm', 'HRM'],
  ['/marketplaces', 'Market'],
  ['/api-integration', 'Integrations'],
  ['/integrations', 'Integrations'],
  ['/automations', 'Integrations'],
  ['/sync', 'Integrations'],
  ['/suppliers', 'Shop'],
  ['/shop', 'Shop'],
  ['/products', 'Shop'],
  ['/orders', 'Orders'],
  ['/crm', 'CRM'],
  ['/warehouses', 'WMS'],
  ['/dictionaries', 'Shop'],
  ['/admin', 'Integrations'],
];

/** Короткие подписи для UI (русский). */
export const PLATFORM_ASSET_LABELS = {
  Shop: 'Каталог / витрина',
  Orders: 'Заказы',
  Market: 'Маркетплейсы',
  Delivery: 'Доставка',
  Logistics: 'Логистика',
  CRM: 'CRM',
  HRM: 'Персонал',
  WMS: 'Склад',
  Integrations: 'Интеграции',
};

export function getPlatformAssetKeyForPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return null;
  for (const [prefix, key] of ROUTE_PLATFORM_ASSET_PREFIXES) {
    if (pathname.startsWith(prefix)) return key;
  }
  return null;
}

/** Companion scene moduleKey map (CMS / setup-health) — longer prefixes first. */
export const COMPANION_MODULE_ROUTE_PREFIXES = [
  ['/settings/waygpt-control', 'waygpt'],
  ['/modules/company-services-booking', 'services'],
  ['/modules/integrations', 'integrations'],
  ['/modules/logistics', 'logistics'],
  ['/modules/delivery', 'delivery'],
  ['/modules/orders', 'orders'],
  ['/modules/finance', 'finance'],
  ['/modules/support', 'support'],
  ['/modules/search', 'search'],
  ['/modules/bonus', 'bonus'],
  ['/modules/files', 'files'],
  ['/modules/power', 'power'],
  ['/modules/legal', 'legal'],
  ['/modules/kassa', 'kassa'],
  ['/modules/feed', 'feed'],
  ['/modules/shop', 'shop'],
  ['/modules/crm', 'crm'],
  ['/modules/hrm', 'hrm'],
  ['/modules/wms', 'warehouses'],
  ['/commerce-hub', 'commerce-hub'],
  ['/ops', 'orders'],
  ['/warehouses', 'warehouses'],
  ['/integrations', 'integrations'],
  ['/analytics', 'analytics'],
  ['/products', 'products'],
  ['/settings', 'settings'],
  ['/finance', 'finance'],
  ['/orders', 'orders'],
  ['/kassa', 'kassa'],
  ['/marking', 'marking'],
  ['/dashboard', 'dashboard'],
  ['/chat', 'waygpt'],
];

export function resolveModuleKey(pathname) {
  const path = String(pathname || '/');
  for (const [prefix, key] of COMPANION_MODULE_ROUTE_PREFIXES) {
    if (path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(prefix)) {
      return key;
    }
  }
  return null;
}

export function listModuleRouteKeys() {
  return Array.from(new Set(COMPANION_MODULE_ROUTE_PREFIXES.map(([, key]) => key)));
}
